<template>
	<div class="mx-auto px-6 lg:px-4 max-w-7xl">
		<slot />
	</div>
</template>

<script lang="ts" setup></script>

<style></style>
